// extracted by mini-css-extract-plugin
export default {"container":"stageSelector_container__SEBfv","stageLabel":"stageSelector_stageLabel__WIKNp","input":"stageSelector_input__3pWNI"};